
// import _ from "lodash";
// import moment from "moment";
// import { Select } from "antd";
// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import styles from "./createTask.module.scss";
// import { ChatService } from "unifiedring-sdk";
// import store from "../../../../context/store/store";
// import taskImg from "../../../../styles/images/task1.svg";
// import { URInput } from "../../../../shared/widgets/input";
// import { URButton } from "../../../../shared/widgets/button";
// import { initialStateModel } from "../../../../models/model";
// import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
// import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
// import {
//   callActionChanges, deleteTask, getCurrentCallDetail, removeTaskList, replaceTaskGuid,
//   SelectDatePicker, toastInformation, userStatusColor
// } from "../../../../base/callService/common";
// import { style } from "wavesurfer.js/src/util";

// type createState = {
//   taskName: string;
//   guid: string;
//   description: string;
//   assignees: Array<any>;
//   allContact: Array<any>;
//   due_date: any;
//   errors: {
//     assigness: string;
//     taskName: string;
//   }
// };
// export default function CreateTask() {
//   const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
//   let taskDetail: any = store.getState().closeCaption.tasklist || [];

//   const [getData, setData] = useState<createState>
//   ({
//     taskName: taskDetail[taskDetail.length - 1].selectkey, description: "",
//     errors: { assigness: "", taskName: "" }, assignees: [],
//     allContact: allReducer.contactReducer.workContacts, due_date: "", guid: taskDetail[taskDetail.length - 1].guid
//   });

//   const taskCancel = () => {
//     deleteTask(getData.guid);
//     callActionChanges('transcript');
//   };

//   const taskCreate = () => {
//     if ((getData.assignees.length === 0) && (getData.taskName.length === 0)) {
//       setData({ ...getData, errors: { assigness: "Select Assignee", taskName: "TaskName is Required" } });
//       return;
//     }
//     if (getData.assignees.length === 0) {
//       setData({ ...getData, errors: { ...getData.errors, assigness: "Select Assignee" } });
//       return;
//     };
//     if (getData.taskName.length === 0) {
//       setData({ ...getData, errors: { ...getData.errors, taskName: "TaskName is Required" } });
//       return;
//     }

//     let { userdetails } = allReducer.loginReducer;
//     let { xmppDetails } = allReducer.chatReducer;
//     if (xmppDetails.resourceid === "") {
//       toastInformation("Something went wrong", "failure");
//       return;
//     }
//     let closeCaption = store.getState().closeCaption || [];
//     let participantInfo: any = [];
//     if (closeCaption.asrCallingFrom === 'callList') {
//       let activeCallDetail: any = getCurrentCallDetail();
//       participantInfo = activeCallDetail.contact || [];
//     }
//     else if (closeCaption.asrCallingFrom === 'voiceMail') {
//       participantInfo = store.getState().detailPageReducer.particularVoiceLog || [];
//     }
//     else { participantInfo = store.getState().detailPageReducer.particularRec || []; }

//     const due_date = getData.due_date === "" ? new Date() : getData.due_date;
//     let data: any = {
//       "summary": getData.taskName,
//       "description": getData.description,
//       "attendee": getData.assignees,
//       "dtstart": (new Date(due_date).getTime() / 1000).toFixed(0),
//       "dtend": (new Date(due_date).getTime() / 1000).toFixed(0),
//       "due_time": 0,
//       "recur_options": "None",
//       "stop_recur": "",
//       "priority": "Low",
//       "report_to": [userdetails.sip_login_id + '@' + userdetails.host_address],
//       "rrule": "",
//       "group_id": "",
//       "sender": {
//         jid: userdetails.sip_login_id + "@" + userdetails.host_address + "/" + xmppDetails.resourceid,
//         sipid: userdetails.sip_login_id
//       },
//       "receiver": { jid: participantInfo['jid'], sipid: participantInfo['sip_login_id'] },
//       "status": false,
//       "action": "",
//       "trigger": "",
//       "duration": "",
//       "reporter_status": "",
//       "creator_status": "In progress",
//       "last_updated_by": "",
//       "thread_id": "",
//       "attachments": [],
//       "completed": {
//         "percentage": [],
//         "type": "",
//         "assignee": []
//       }
//     };

//     console.log("tast creation data is", data);

//     /*
//     message: "Task summary: [three] sent successfully"
//     msgid: "32a6f42b-61fd-43f4-9ff9-a1f6c19d1650"
//     status: "OK"
//     statusCode: 200
//     uid: "f54858ae-f236-49c5-9154-1c8a4673cdaa"
//     */

//     new ChatService().saveTask(data)
//       .then((res: any) => {
//         console.log("res is", res);
//         if (res.statusCode === 200) {
//           toastInformation("Task created Successfully", "success");
//           replaceTaskGuid(getData.guid, res.uid, participantInfo);
//           callActionChanges('transcript');
//         }
//         else {
//           toastInformation("Something went Wrong try again", "failure");
//           removeTaskList(getData.guid);
//           callActionChanges('transcript');
//         }
//       }).catch((error: any) => {
//         toastInformation(error, "failure");
//         removeTaskList(getData.guid);
//         callActionChanges('transcript');
//       });
//   };

//   const handleInputChange = (name: string, e: any) => {
//     setData({ ...getData, [name]: e.target.value, errors: { ...getData.errors, taskName: "" } });
//   };

//   const selectDropdown = (value: any) => {
//     setData({ ...getData, assignees: value, errors: { ...getData.errors, assigness: "" } });
//   };

//   const handleDateChange = (value: any) => {
//     var day = moment(new Date(value), 'DD/MM/YYYY');
//     setData({ ...getData, due_date: day });
//   };

//   const searchContact = (e: any) => {
//     let searchName = e.toLowerCase();
//     if (searchName !== "") {
//       let filtered = _.filter(allReducer.contactReducer.workContacts, function(name: any) {
//         return name.caller_id?.toLowerCase().includes(searchName) ||
//           name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName);
//       });
//       setData({ ...getData, allContact: filtered });
//     }
//     else {
//       if (searchName === "") {
//         setData({ ...getData, allContact: allReducer.contactReducer.workContacts });
//       }
//     }
//   };
//   let len = Math.round((getData.allContact?.length / 8));
//   let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
//   let dueData: any = SelectDatePicker();
//   return (
//     <>
//       <div className={styles.rightsidebar}>
//         <div className={styles.toplayers}>
//           <h3>New Task</h3>
//           <span className="icon_close"></span>
//         </div>
//         <div className={styles.middlelayers}>
//           <div className={styles.fieldsin}>
//             <label>Tasks Name</label>
//             <URInput placeHolder="Type what things to do" className={styles.normalinput}
//               value={getData.taskName} onChange={(e: any) => handleInputChange('taskName', e)} />
//             {getData.errors.taskName !== "" &&
//               <span className="error fortaskss">{getData.errors.taskName}</span>
//             }
//           </div>

//           <div className={styles.fieldsin}>
//             <label>Assignee</label>
//             <Select
//               mode="multiple"
//               style={{ width: '100%' }}
//               placeholder="Search name or extension"
//               className="newselects taspage"
//               showSearch={true}
//               filterOption={false}
//               onChange={selectDropdown}
//               onSearch={searchContact}
//             >
//               {getData.allContact?.map((contactName: any, index: any) => {

//                 return <option key={index} value={contactName.jid}>
//                   <div className="dropdowndesign">
//                     <URAvatarGroup className={`${'lefts size32'} ${styles.avatarset} colorBG${random_color[index]}`}
//                       profileInfo={
//                         (contactName.ImageURL && contactName.ImageURL !== "") ?
//                           (<>
//                             <img src={contactName.imageURL} alt="" />
//                             <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
//                           (<>
//                             <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
//                             <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
//                           </>)
//                       } />
//                     <div className="names">{contactName.caller_id ? contactName.caller_id :
//                       contactName.team_name ? contactName.team_name : ""
//                     }</div>
//                     <div className="ext">{contactName.ext}</div>
//                   </div>
//                 </option>;
//               })}
//             </Select>
//             {getData.errors.assigness !== "" &&
//               <span className="error fortasks">{getData.errors.assigness}</span>
//             }
//           </div>

//           <div className={styles.fieldsin}>
//             <label>Due Date</label>

//             <div className={styles.insideicon}>
//               <img src={taskImg} alt="" />
//               <Select
//                 defaultValue="No date selected"
//                 style={{ width: '100%' }} className="duedateselect" onChange={handleDateChange}>
//                 {dueData && dueData.map((device: any) => {
//                   return <option key={device} value={`${device}`}>{device}</option>;
//                 })}
//               </Select>
//             </div>
//           </div>

//           <div className={styles.fieldsin}>
//             <label>Description</label>
//             <textarea name="" placeholder="Write a task description"
//               onChange={(e: any) => handleInputChange('description', e)}></textarea>
//           </div>
//         </div>
//         <div className={styles.bottomlayers}>
//           <URButton name="Cancel" className="urButton buttonWhite" onClick={taskCancel} />
//           <URButton name="Save" className="urButton buttonBlue marlftmin" onClick={taskCreate} />
//         </div>
//       </div>
//     </>
//   );
// };












import React, { useEffect, useState } from "react";
import styles from "../../../contacts/rightsidebar/scss/taskcreate.module.scss";

//import ReactQuill from 'react-quill'; // Typescript
import { Select, DatePicker } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { URButton } from "../../../../shared/widgets/button";
import { URInput } from "../../../../shared/widgets/input";
import taskImg from "../../../../styles/images/task1.svg";
//import UserInputwithImage from "../../../../shared/widgets/inputwithimage";
import { useSelector } from "react-redux";
import { callActionChanges, deleteTask, userStatusColor } from "../../../../base/callService/common";
import { getcontactDetail, SearchFilter } from "../../../../base/utils";
import store from "../../../../context/store/store";
import { chatwindowDetails, contacts, contactwindowDetails,
  initialStateModel, LoginState } from "../../../../models/model";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { contactService } from "../../../../base/contactService";
import { chatSideWindow } from "../../../../base/eventService/eventApiService";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
type TaskPageState ={
  taskName:string,
  description:string,
  nameError:boolean,
  assigneeError:boolean,
  dueDate:any,
  dueError:boolean,
  assigneeArray:any,
  key: any
  
}

export default function CreateTask(props:any){
  let isContact= window.location.pathname=== "/contacts"?true:false;
  let { contactWindowDetails}:contactwindowDetails =
  useSelector((state: initialStateModel) =>state.contactWindowReducer);
  //const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
 // const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let {chatWindowDetails ,isMySpace}=chatWindow;
  //let {userdetails}= loginDetails;
  //let {xmppDetails}= chatReducer;

  let taskDetail: any = store.getState().closeCaption.tasklist || [];


  let { workContacts }: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  
  const [createTask, setcreateTask] = useState<TaskPageState>({
    taskName: taskDetail[taskDetail.length - 1].selectkey,
    description: "", key: "",
    nameError: false, assigneeError: false, dueDate: "", dueError: false, assigneeArray: []
  });
  

  const [selectMember, setselectMember] = useState({
    contactList: workContacts, searchContactList: workContacts,contactDetail:[],
    selectedmember:[],guid: taskDetail[taskDetail.length - 1].guid
  });

  const disabledDate = (from: any, current: any) => {
    return new Date(from.setDate(from.getDate() - 1)) >= current;
  };

  let len = Math.ceil((selectMember?.searchContactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  
  useEffect(() => {
    let selectedContact:any=[];
    if(isContact && 'sip_login_id'in contactWindowDetails){
     
      selectedContact.push(contactWindowDetails.sip_login_id);
      let contactDetials:any=[];
      contactDetials.push(contactWindowDetails);
      setcreateTask({...createTask, assigneeArray:selectedContact});
      setselectMember({...selectMember,selectedmember:selectedContact,contactDetail:contactDetials});
    }
    else if(!isMySpace && 'sip_login_id'in contactWindowDetails){
      selectedContact.push(chatWindowDetails.sip_login_id);
      let contactDetials:any=[];
      contactDetials.push(chatWindowDetails);
      setcreateTask({...createTask, assigneeArray:selectedContact});
      setselectMember({...selectMember,selectedmember:selectedContact,contactDetail:contactDetials});
    }

  }, [contactWindowDetails,chatWindowDetails]);

  const onSaveTask=()=>{
    if((createTask.taskName.trim() === "" && selectMember.selectedmember.length < 1 && createTask.dueDate === "")){
      setcreateTask({...createTask,nameError:true, assigneeError:true, dueError:true});
    }else if(createTask.taskName.trim() === ""){
      setcreateTask({...createTask,nameError:true});
    }else if(selectMember.selectedmember.length < 1){
      setcreateTask({...createTask, assigneeError:true});
    }
    
    else if(!createTask.dueDate){
      setcreateTask({...createTask,dueError:true});
    }
    else
    {
      let assigneeArray:any= [];
      selectMember?.contactDetail.map((list:any)=>{
        assigneeArray.push(list.jid);
      });
      
      contactService.createContactTask(createTask);
      if(isContact){
        props.handleToggle();
        } else {
          chatSideWindow(true,"",{});
        }
        setcreateTask({...createTask, taskName:"",description:"",nameError:false, assigneeError:false});
      
    }
    // let closeCaption = store.getState().closeCaption || [];
    //     let participantInfo: any = [];
    //     if (closeCaption.asrCallingFrom === 'callList') {
    //       let activeCallDetail: any = getCurrentCallDetail();
    //       participantInfo = activeCallDetail.contact || [];
    //     }
    //     else if (closeCaption.asrCallingFrom === 'voiceMail') {
    //       participantInfo = store.getState().detailPageReducer.particularVoiceLog || [];
    //     }
    //     else { participantInfo = store.getState().detailPageReducer.particularRec || []; }

    // replaceTaskGuid(guid, res.uid, participantInfo);
              callActionChanges('transcript');
  };

  const handleDate=(date:any,dateString:any)=>{

    if(date){
      setcreateTask({...createTask, dueDate:date,dueError:false});
    }else{
      setcreateTask({...createTask, dueDate:"",dueError:true});
    }
    
  };

  // const  onCancel=()=>{
  //   setcreateTask({...createTask,taskName:"",description:"",nameError:false, assigneeError:false});
   
  //   if(!isContact){
  //     chatSideWindow(true,"",{});
  //   }
  //   else{
  //     props.handleToggle();
  //   }
  // };

    const taskCancel = () => {
    deleteTask(selectMember.guid);
    callActionChanges('transcript');
  };

  const handleChange=(e:any)=>{
    if(e.target.name === 'taskName'){
      setcreateTask({...createTask,nameError:false, [e.target.name]: e.target.value});
    }
    else{
      setcreateTask({...createTask,[e.target.name]: e.target.value});
    }
  };

  const onChangeSelectMembers =(e:any)=>{
    let {userdetails}:LoginState = store.getState().loginReducer;
    let contact:any=
    e.map((item:string)=>
    {
      return getcontactDetail(item.toString(),selectMember.contactList,userdetails);
    });
    setselectMember({
      ...selectMember, selectedmember: e,
      searchContactList: selectMember.contactList,contactDetail:contact
    });
    setcreateTask({...createTask, assigneeError:false,assigneeArray:e});
  };

  const onSearchMembers = (value: any) => {
    let response = SearchFilter(selectMember.contactList, value.toLowerCase());
    setselectMember({ ...selectMember, searchContactList: response });
  
  };

  return (
    <>
      <div className={`customdates ${styles.rightsidebar}`}>
        <div className={styles.toplayers}>
          <h3>New Task</h3>
          <span className="icon_close" onClick={taskCancel}></span>
        </div>
        <div className={styles.middlelayers}>
          <label>Task Name</label>
          <URInput placeHolder="Type what things to do" name="taskName"
            className={styles.normalinput} value={createTask.taskName} onChange={handleChange}/>
          {createTask?.nameError && <span className="error">This task needs a name</span>}
          <label>Assigned To</label>
          <div className={styles.insideicon}>
            <img src={taskImg} alt="" />
            <Select
              mode="multiple"
              onChange={(e: any) => onChangeSelectMembers(e)}
              onSearch={onSearchMembers}
              style={{ width: '100%' }}
              filterOption={false}
              showSearch={true}
              value={selectMember.selectedmember}
              placeholder="Select Employee"
              className="createNewSel"
              dropdownClassName="newChatSel">
              { selectMember?.searchContactList?.map((contact:any,index:any)=>{
               
                let name= contact?.caller_id ?contact?.caller_id : contact?.team_name;
                return(
             
                  <option key={index}
                    value={contact.sip_login_id?contact.sip_login_id: `con${contact.team_id}`}>
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                        <URAvatarGroup className={`${'lefts size22'} ${styles.avatarset} colorBG${random_color[index]}`} profileInfo={<>
                          {contact.ImageURL ?
                            <img src={contact.ImageURL} alt="" /> :
                            <span>{contact.caller_id?.charAt(0)}</span>}
                          <URStatusDot
                            className={userStatusColor(contact?.user_status,'small')}/>
                        </> } />
                      </div>
                      <div className="names">{name && name}</div>
                      {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                    </div>
                  </option>
              
                );

            
              })  }
         
            </Select>
          </div>
          {createTask?.assigneeError && <span className="error">Assign task to Someone</span>}
          <label>Due Date</label>
          <div className={styles.insideicon}>
            <DatePicker className="customDatepicker"
              disabledDate={(e) => disabledDate(new Date(), e)}
              onChange={(date: any, dateString: any)=>handleDate(date, dateString)} format="DD/MM/YYYY"
              dropdownClassName='datepickerDropdown' placeholder='Due date' /></div>
          {createTask.dueError && <span className="error">Task due date required</span>}
          <label>Description</label>
          <textarea name="description" onChange={handleChange}
            value={createTask.description} placeholder="Write a task description"></textarea>
        </div>
        <div className={styles.bottomlayers}>
          <URButton name="Cancel" onClick={taskCancel} className='urButton buttonWhite buttonMd mr8' />
          <URButton name="Save" onClick={onSaveTask} className='urButton buttonBlue buttonMd' />
        </div>
      </div>
    </>
  );

}
